import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import { SectionHeader } from '@/components/SectionHeader';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Container)`
  display: flex;
  ${({ theme }) => css`
    padding-top: ${theme.spacing(7.5)};
  `}
`;

export const PictureWrapper = styled(Box)`
  &&& {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    .watch-card {
      height: auto;
      min-height: auto;
    }
    .next-image {
      width: 100%;
      height: auto;
      display: block;
      object-fit: cover;

      ${({ theme }) => css`
        ${theme.media.md.up} {
          height: 100%;
          max-height: 700px;
        }
      `}
    }
  }
`;

export const Picture = styled(NextImageWithLoader)``;

export const ContentWrapper = styled(Box)`
  width: 100%;
`;

export const Content = styled(Box)`
  width: 416px;
`;

export const WarrantyLabel = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.secondary};
  `}
`;

export const WarrantyBadgeAndDatesWrapper = styled(Flex)`
  align-items: center;
`;
export const WarrantyOperation = styled(Typography)`
  ${({ theme }) => css`
    font-size: 12px;
    color: ${theme.colors.primaryDark};
    margin-bottom: ${theme.spacing(0.5)};
  `}
`;

export const ActiveBadge = styled(Box)<{ isValid?: boolean }>`
  ${({ isValid, theme }) => css`
    display: inline-block;
    height: 30px;
    background-color: ${isValid ? theme.colors.success : theme.colors.error};
    padding: ${theme.spacing(1)};
    margin-right: ${theme.spacing(1)};
    p {
      text-transform: uppercase;
      transform: translateY(-1px);
      color: ${theme.colors.white};
      font-family: ${theme.fontFamilies.italianPlate};
      font-size: ${theme.fontSizes.h5};
    }
  `}
`;

export const ValidityText = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.secondaryGrey};
  `}
`;

export const LastEstimateWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;
export const LastEstimateText = styled(Typography)`
  ${({ theme }) => css`
    font-size: 14px;
    color: ${theme.colors.primaryBlue};
  `}
`;
export const estimateTimeText = styled(Typography)`
  font-weight: bold;
  margin-left: 4px;
`;

export const DownloadablesWrapper = styled(Container)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 8px;
`;

export const NeedAServiceButton = styled(LegacyButton)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const LinkButton = styled(LegacyButton)`
  gap: 0;
  padding: 0;
  height: auto;
  width: auto;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(0.5)};
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const Divider = styled(Box)`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.primaryAdd6};
    margin: ${theme.spacing(1.5, 0)};
  `}
`;

export const WarrantyTitle = styled(SectionHeader)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.medium};
    margin-bottom: 0;
  `}
`;
